import type { CSSProperties } from 'react';
import { Section } from '../components/Section';
import { PANELISTS, type Panelist } from '../data/panelists';

export function Panelists(): JSX.Element {
  return (
    <Section
      id="panelists"
      label="THE LINEUP"
      title={<>Five engineers. Two bots. One bath.</>}
      kicker="The panelists for episode 01. Click any of them to read their stance, debate record, and the dirt we have on file."
    >
      <div className="grid gap-5" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}>
        {PANELISTS.map((p) => (
          <PanelistCard key={p.id} panelist={p} />
        ))}
      </div>
    </Section>
  );
}

function PanelistCard({ panelist: p }: { panelist: Panelist }): JSX.Element {
  const isAI = p.type === 'ai';
  return (
    <button
      type="button"
      className="group relative flex w-full flex-col overflow-hidden rounded-[14px] border-2 border-ink bg-paper p-0 text-left"
      style={{ boxShadow: '4px 4px 0 rgb(var(--color-ink))', transition: 'transform 0.12s, box-shadow 0.12s' }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translate(-2px, -2px)';
        e.currentTarget.style.boxShadow = '6px 6px 0 rgb(var(--color-ink))';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translate(0, 0)';
        e.currentTarget.style.boxShadow = '4px 4px 0 rgb(var(--color-ink))';
      }}
    >
      <div
        className="relative flex w-full items-center justify-center border-b-2 border-ink font-display text-7xl font-black text-white"
        style={{
          aspectRatio: '4 / 5',
          background: p.color,
          backgroundImage: p.photo ? `url("${p.photo}")` : 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
        }}
      >
        {!p.photo && p.initials}
        <div
          className="absolute font-mono text-[10px] font-bold tracking-[0.08em] border-[1.5px] border-ink"
          style={{
            top: 12,
            right: 12,
            padding: '4px 9px',
            borderRadius: 999,
            background: isAI ? 'rgb(var(--color-ai))' : 'rgb(var(--color-beak))',
            color: isAI ? 'rgb(var(--color-ink))' : '#fff',
          } as CSSProperties}
        >
          {isAI ? 'AI' : 'HUMAN'}
        </div>
        {isAI && (
          <div
            className="absolute flex items-center justify-center border-2 border-ink bg-duck text-lg"
            style={{ bottom: 12, left: 12, width: 36, height: 36, borderRadius: '50%' }}
          >
            🦆
          </div>
        )}
      </div>
      <div className="flex flex-1 flex-col gap-3 p-[18px]">
        <div>
          <div className="font-display text-[22px] font-extrabold leading-tight text-ink">{p.name}</div>
          <div className="mt-1 text-[13px] text-ink-soft">{p.title}</div>
        </div>
        <div className="text-sm italic leading-snug text-ink">"{p.quote}"</div>
        <div className="mt-auto flex items-center justify-between border-t border-[rgb(var(--color-ink)/12%)] pt-2 font-mono text-[11px] text-ink-soft">
          <span>STANCE: {p.stance}</span>
          <span>
            {p.debateRecord.wins}W·{p.debateRecord.losses}L·{p.debateRecord.draws}D
          </span>
        </div>
      </div>
    </button>
  );
}
